import {urlParams} from "../UrlParamsLoader/UrlParamsLoader";
import storage from "../Storage/Storage";

export function isCurrencyHidden() {
	if(typeof window !== "undefined") {
		if(sessionStorage.getItem("hideCurrency") === "true") {
			return true;
		}
		if(storage.get("hideCurrency") === true) {
			return true;
		}
	}

	const currency = urlParams.get("currency");
	return currency != null && currency.toLowerCase() === "hidden";
}

export function applyCurrencyVisibilityFromUrl() {
	const hidden = isCurrencyHidden();
	storage.set("hideCurrency", hidden);
	sessionStorage.setItem("hideCurrency", hidden ? "true" : "false");

	if(typeof document !== "undefined" && hidden) {
		document.body.classList.add("hide-currency");
	}
}

export function displayCurrencyCode(code) {
	if(isCurrencyHidden()) {
		return "";
	}

	return code ?? "";
}
